import { mapActions } from "vuex";
import { types as Category } from "@/store/yzgCategory";
import { types as Search } from "@/store/search";
import { getGeocoder } from "@/libs/api.js";


const actions = mapActions({
  getNavList: Category.CATEGORY_NAV_LIST,
  getSearchList: Search.SEARCH_LIST,
});
export default {
  name: "Category",
  components: {},
  data() {
    return {
      link: `//h5.${this.$uleUrl()}/yxd/community/item/itemPage/`,
      isEmpty: "",
      searchValue: "",
      boxHeight: 0,
      sidebarWidth: 0,
      active: 0,
      currentNav: "", // 右侧顶部选中
      leftNavList: [],
      freshActType:'',
      categoryNavShow: false,
      rightNavList: [],
      cont: [],
      query: {
        clientCallType: "h5",
        pageIndex: 1,
        pageSize: 500,
        cateId: 0,
        keyword: "",
        area: "", //定位省市区id
      },
      showTip: false, // 微信分享提示
      overShow: true, // 当前页遮罩
      loading: false,
      finished: false,
      isLoad: false,
      finishedText: "",
      currentCity_detail: "定位信息", // 定位信息
      mapHref: "https://apis.map.qq.com/tools/locpicker?search=1&type=0&key=OTHBZ-3VGKV-UU4P3-ULQNZ-7DPSS-KOFT4&referer=myapp",
      isShowRightTitle: true, // 右侧二级分类是否显示
    };
  },
  created() {
    if (this.$route.query.adcode) {
      // 地址里有adcode
      this.query.area = this.$route.query.adcode;
      this.currentCity_detail = this.$route.query.addr;
      this.getCategoryList();
    } else if (this.$route.query.latng) {
      // 地址里是经纬度adcode
      this.currentCity_detail = this.$route.query.addr;
      this.getLocation(this.$route.query.latng); //解析经纬度获取adcode后再请求数据
    } else {
      //如果都没有直接跳地图
      setTimeout(() => {
        this.$router.push("/others/positionLost");
      }, 500);
    }
  },
  mounted() {
    // 获取页面中间高度
    this.boxHeight = document.documentElement.clientHeight - document.querySelector(".search").clientHeight - 10 + "px";
    this.sidebarWidth = document.querySelector(".van-sidebar").clientWidth + "px";
    document.querySelector(".category-nav").style.left = this.sidebarWidth;
    document.querySelector(".overlay").style.height = document.documentElement.clientHeight - document.querySelector(".search").clientHeight - 10 + "px";
    if(this.$route.query.freshActType){
      this.freshActType = this.$route.query.freshActType
    }
  },
  methods: {
    ...actions,
    // 右侧箭头切换
    showMoreCategory() {
      this.categoryNavShow = !this.categoryNavShow;
    },
    // 获取分类目录
    getCategoryList() {
      this.getNavList(this.query).then((res) => {
        this.overShow = false;
        if (res.data.category.length > 0) {
          res.data.category.forEach((item) => {
            this.leftNavList.push({
              text: item.name,
              id: item.id,
              children: item.children,
            });
            this.cont.push({ goods: [] });
          });
          this.leftNavList.map((item, index) => {
            if (item.id == this.$route.query.categoryId) {
              this.active = index;
            }
          });
          this.rightNavList = this.leftNavList[this.active].children;

          // 如果是北京,隐藏二级分类
          if (this.query.area.indexOf(110) == 0) {
            this.isShowRightTitle = false;
            this.query.cateId = this.leftNavList[this.active].id;
          } else {
            this.isShowRightTitle = true;
            this.query.cateId = this.leftNavList[this.active]["children"][0].id;
            this.currentNav = this.leftNavList[this.active]["children"][0].id;
          }
          this.fetch();
        } else {
          console.log("接口没分类数据");
        }
      });
    },
    // 获取商品列表
    fetch() {
      // this.currentNav = this.rightNavList[this.active].id;
      // this.query.cateId = this.leftNavList[this.active].id;
      this.getSearchList(this.query).then((res) => {
        this.loading = false;
        if (res.returnCode === "0000") {
          // 无数据
          if (res.data.Listings.length === 0) {
            this.finished = true;
          } else {
            // 活动列表下拉load事件
            if (document.querySelector(".van-tree-select__content").scrollTop === 0) {
              setTimeout(() => {
                document.querySelector(".van-tree-select__content").scrollTo(0, 1);
              }, 10);
            }
            res.data.Listings.forEach((item) => {
              if (~item.imgurl.indexOf("http://")) {
                item.imgurl = item.imgurl.replace("http://", "https://");
              }
            });
            this.query.pageIndex++;
            let totalPage = Math.floor(this.pageCount(res.data.totalCount));
            this.cont[0]["goods"] = this.cont[0]["goods"].concat(res.data.Listings);
            if (this.query.pageIndex > totalPage) {
              this.finished = true;
              this.finishedText = "我已到达底部, 暂无其他数据啦~~";
            } else {
              this.finished = false;
            }
          }
        } else {
          this.finished = true;
          this.finishedText = "我已到达底部, 暂无其他数据啦~~";
        }
      });
    },
    // 计算总页数
    pageCount(totalCount) {
      return (totalCount + this.query.pageSize - 1) / this.query.pageSize;
    },
    // 左侧切换
    changeTab(index) {
      if (index !== 0) {
        document.querySelector(".van-tree-select__content").classList.add("left-top-radius");
        document.querySelector(".category-nav").classList.add("left-top-radius");
      } else {
        document.querySelector(".van-tree-select__content").classList.remove("left-top-radius");
        document.querySelector(".category-nav").classList.remove("left-top-radius");
      }
      this.cont[0]["goods"] = [];
      this.rightNavList = this.leftNavList[index].children;
      this.currentNav = this.rightNavList[0].id;
      this.query.pageIndex = 1;
      this.query.cateId = this.currentNav;
      this.loading = false;
      this.finished = false;
      this.isLoad = true;
      // this.fetch();
    },
    // 右侧点击
    rightNavChange(item) {
      this.cont[0]["goods"] = [];
      this.query.cateId = item.id;
      this.currentNav = item.id;
      this.query.pageIndex = 1;
      this.loading = false;
      this.finished = false;
      this.isLoad = true;
    },
    // 分享
    share(item) {
      let link = this.link + item.listId;
      this.goodsShare(item.listName, item.listName, link, item.defImgUrl, item.listId, item.price, item.price,this.freshActType);
    },
    toSelectAddress() {
      let href = window.location.href;
      let urlArr = href.split("?");
      this.mapHref = this.mapHref + `&backurl=${urlArr[0]}`;
      location.href = this.mapHref;
    },
    getLocation(Location) {
      let data = {
        key: "OTHBZ-3VGKV-UU4P3-ULQNZ-7DPSS-KOFT4",
        callbackName: "QQmap",
        output: "jsonp",
        location: Location,
        get_poi: 1,
      };
      getGeocoder(data, "", "callback")
        .then((json) => {
          let data = json.result;
          let adcode = data.ad_info.adcode;
          this.query.area = adcode;
          this.getCategoryList();
        })
        .catch((err) => {
          this.$toast(err);
        });
    },
  },
};
